import React from 'react';
import { MergeIngredientInputs } from '../mergeIngredients/MergeIngredientInputs';

export const SingleInputField = (props) => {
  const { fields } = props;
  return (
    <div id='singleinputfield-wrapper'>
      {fields.map((inputField) => {
        return (
          <>
            <div id='singleinputfield-container' className="ingredient-input-container">
              <MergeIngredientInputs inputField={inputField}></MergeIngredientInputs>
            </div>
          </>
        );
      })}
    </div>
  );
};
